// https://www.geeksforgeeks.org/tree-traversals-inorder-preorder-and-postorder/#tree-traversal-meaning
// https://www.geeksforgeeks.org/construct-tree-from-given-inorder-and-preorder-traversal/?ref=ml_lbp


// https://www.npmjs.com/package/react-tree-graph
// https://github.com/jpb12/react-tree-graph
// https://jpb12.github.io/react-tree-graph/?path=/docs/introduction--docs
// https://codesandbox.io/p/sandbox/tree-wmgs9?file=%2Fsrc%2Fdata.js
import {useCallback, useEffect, useLayoutEffect, useRef, useState} from "react";
import {AnimatedTree} from 'react-tree-graph';
import {TreeNode} from "./data";
//import {organigrammaFPNet} from "./de_padova";
import {organigrammaFPNet} from "./gpz";
//import {cloneDeep} from "lodash";
import styles from './organigrammi.module.css';

const DEFAULT_DEPTH = 9 // permette di limitare il numero di nodi x screen
const cloneWithDepth = (object: any, depth: number = DEFAULT_DEPTH): any => {
    if (depth === -1) return undefined
    if (typeof object !== 'object') return object

    if (Array.isArray(object)) {
        return object
            .map((val) => cloneWithDepth(val, depth - 1))
            .filter((val) => val !== undefined)
    }

    const clone: any = {}

    for (const key in object) {
        if (typeof object['key'] === 'object' && depth - 1 === -1) {
            continue
        }

        const clonedValue = cloneWithDepth(object[key], depth - 1)

        if (clonedValue !== undefined) {
            clone[key] = clonedValue
        }
    }

    return clone
}
const cloneDeep = cloneWithDepth;

type NodeParams = { node: TreeNode, path: string[] };
const emptyTree: TreeNode = {name: 'none', id: 0, children: []};
//const emptyTree = data;
const organigramma = organigrammaFPNet;
export const Organigrammi = () => {
    const [rootNode, setRootNode] = useState<TreeNode>(emptyTree);
    const [data, setData] = useState<TreeNode>(cloneDeep(emptyTree));
    const [path, setPath] = useState<string[]>([emptyTree.name]);

    useEffect(() => {
        if (organigramma && organigramma.length) {
            //const root: TreeNode = {name: organigramma[0].codiceFiscale, id: organigramma[0].idNodo || 0, children: []};
            const root: TreeNode = {name: organigramma[0].cognome+' '+organigramma[0].nome, id: organigramma[0].idNodo || 0, children: []};
            let treeNode: TreeNode | undefined = root;
            const cercaNodo = (treeNode: TreeNode, id: number): TreeNode | undefined => {
                if (treeNode.id === id) {
                    return treeNode;
                } else if (treeNode.children) {
                    for (const nodo of treeNode.children) {
                        const r = cercaNodo(nodo, id);
                        if (r) return r;
                    }
                    //const r: TreeNode | undefined = treeNode.children.find(nodo => cercaNodo(nodo, id)?.id===id);
                    //return r;
                }
                return undefined;
            };
            let idNodoPadre = organigramma[0].idNodo;
            organigramma.forEach((nodo, index) => {
                if (index > 0) {
                    if (idNodoPadre !== nodo.idNodoPadre) {

                        treeNode = cercaNodo(root, nodo.idNodoPadre);
                    }
                    if (treeNode) {

                        //treeNode.children!.push({name: nodo.codiceFiscale, cognome: nodo.cognome, nome: nodo.nome, id: nodo.idNodo, children: []});
                        treeNode.children!.push({name: nodo.cognome+' '+nodo.nome, cognome: nodo.cognome, nome: nodo.nome, id: nodo.idNodo, children: []});
                    }
                }
            });
            setRootNode(root);
            setData(cloneDeep(root));
            setPath([root.name])
        }
    }, []);

    //
    const [canvasWidth, setCanvasWidth] = useState(0)
    const [canvasHeight, setCanvasHeight] = useState(0)
    const {innerWidth, innerHeight} = useWindowInnerSize()
    const canvasWrapper = useRef<HTMLDivElement | null>(null)
    const setCanvasSize = useCallback(() => {
        const {clientWidth, clientHeight} = canvasWrapper.current!

        setCanvasWidth(clientWidth)
        setCanvasHeight(clientHeight)
    }, [])

    useEffect(setCanvasSize, [setCanvasSize])

    useLayoutEffect(() => {
        setCanvasWidth(0)
        setCanvasHeight(0)
    }, [innerWidth, innerHeight])

    /*useEffect(() => () => {
        let isMounted = true

        requestAnimationFrame(() => isMounted && setCanvasSize())

        return () => isMounted = false
    }, [innerWidth, innerHeight, setCanvasSize])*/

    const changeNode = ({node, path}: NodeParams) => {
        setPath(path)
        setData(node)
    }
    const findNode = (key: any, node = rootNode, parentPath: string[] = []): NodeParams | undefined => {
        const path = [...parentPath, node.name]

        if (node.name === key) {
            return {node: cloneDeep(node), path}
        }

        if (Array.isArray(node.children)) {
            for (const child of node.children) {
                const found = findNode(key, child, path)

                if (found) return found
            }
        }
    }
    const handleClick = (_: any, key: any) => {
        const p = findNode(key)
        if (p)
            changeNode(p);
    }

    return (
        <div style={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
        }}>
            <div>
                <div>
                    {path.map((path) => (
                        <button
                            style={{
                                margin: '0',
                                border: 'none',
                                outline: 'none',
                                background: 'none',
                                padding: '0 0.1rem',
                                textDecoration: 'underline',
                                cursor: data.name === path ? '' : 'pointer',
                                color: data.name === path ? 'black' : 'blue',
                            }}
                            key={path}
                            onClick={() => {
                                //changeNode(findNode(path))
                                const p = findNode(path)
                                if (p)
                                    changeNode(p);
                            }
                            }
                        >
                            {path}
                        </button>
                    ))}
                </div>
            </div>
            <div style={{flexGrow: 1}} ref={canvasWrapper}>
                <AnimatedTree

                    /*animated={true}*/
                    data={data}
                    /*
                                        width={canvasWidth}
                                        height={canvasHeight}
                    */
                    width={1000}
                    height={1000}
                    /*keyProp={'id'}*/
                    /*nodeRadius={15}*/
                    svgProps={{style: {backgroundColor: 'lightgray'}}}
                    gProps={{className: styles.node, onClick: handleClick}}
                    margins={{top: 20, bottom: 10, left: 20, right: 150}}
                />
            </div>
        </div>
    )
}


const useWindowInnerSize = () => {
    const [innerWidth, setInnerWidth] = useState(window.innerWidth)
    const [innerHeight, setInnerHeight] = useState(window.innerHeight)
    const hanldeResize = useCallback(() => {
        setInnerWidth(window.innerWidth)
        setInnerHeight(window.innerHeight)
    }, [])

    useEffect(() => {
        window.addEventListener('resize', hanldeResize)

        return () => window.removeEventListener('resize', hanldeResize)
    }, [hanldeResize])


    return {
        innerWidth,
        innerHeight,
    }
}